export const splitChunks = <T>(targetArr: T[], chunkSize: number): T[][]  => {
    const chunkLength = Math.ceil(targetArr.length / chunkSize);
    const tempArr = Array(chunkLength).fill(1);
    const res = tempArr.map((_, i) => targetArr.slice(i * chunkSize, (i + 1) * chunkSize));
    return res;
};



// WEBPACK FOOTER //
// ./src/utils/splitChunks.ts